import { fork, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';
import {
  WalletApi, WalletControllerDtoContentsWalletListResponse,
  WalletControllerDtoDepositAddressRequest, WalletControllerDtoDepositRequest,
} from '../../models/src';
import { getErrorMessage } from '../../../utils/serverErrorCheck';
import WalletControllerDtoDepositAddressResponse
  from '../../models/src/model/WalletControllerDtoDepositAddressResponse';
import { DEPOSIT_ADDRESS, DEPOSIT_REQUEST, CONTENTS_WALLET_LIST_REQUEST } from '../../constants/wallet/depositConstants';
import BaseResponse from '../../models/src/model/BaseResponse';

const api = new WalletApi(config.API_CLIENT);

function* depositAddressRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new WalletControllerDtoDepositAddressRequest();
    requestData.walletNo = payload.walletNo;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiWalletDepositAddressPost({ walletControllerDtoDepositAddressRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, WalletControllerDtoDepositAddressResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* depositRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new WalletControllerDtoDepositRequest();
    requestData.walletNo = payload.walletNo;
    requestData.tokenType = payload.tokenType;
    requestData.amount = payload.amount;
    requestData.walletAddress = payload.walletAddress;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiWalletDepositPost({ walletControllerDtoDepositRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* contentsWalletListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const result = yield api.apiWalletContentsWalletListPost( () => {});
    const data = api.apiClient.deserialize(result, WalletControllerDtoContentsWalletListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* depositRootSaga() {
  yield all([
    takeEvery(DEPOSIT_ADDRESS, depositAddressRequestSaga),
    takeEvery(DEPOSIT_REQUEST, depositRequestSaga),
    takeEvery(CONTENTS_WALLET_LIST_REQUEST, contentsWalletListRequestSaga),
  ]);
}

const depositSagas = [
  fork(depositRootSaga),
];

export default depositSagas;
